module.exports = __webpack_public_path__ + "img/icon_avatar.f1d240e4.png";